import { atom } from "jotai";
import ObjectStorage from "../modules/ObjectStorage";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import { StorageConstants } from "../constants/AppConstants";
import { ORDER_TYPE_OPTIONS } from "../constants/AppConstants";

const products = atom([]);
const allProducts = atom([]);
const cart = atom(
  Array.isArray(ObjectStorage.getItem(StorageConstants.CART_DATA))
    ? ObjectStorage.getItem(StorageConstants.CART_DATA)
    : [],
);
const countersListState = atom([]);
const responsive = atom({
  width: window.innerWidth,
  height: window.innerHeight,
});
const locationState = atom({
  key: "locationState",
  default: {
    latitude: 0,
    longitude: 0,
  },
});
const orderId = atom("");
const selectedOrderType = atom("");
const noStockProducts = atom([]);
const gstData = atom({});
const configuration = atom({});
const infoDialog = atom({ show: false, title: "", desc: "", content: "" });
const selectedCounterState = atom(
  isEmpty(ObjectStorage.getItem(StorageConstants.COUNTER_ID))
    ? null
    : ObjectStorage.getItem(StorageConstants.COUNTER_ID),
);
const merchantDetailsState = atom({});
const calculatedTotalAtom = atom({});
const IsDarkChange = atom(true);
const accessToken = atom('');
const orderType = atom(get(ORDER_TYPE_OPTIONS, "0"));
export {
  allProducts,
  locationState,
  calculatedTotalAtom,
  cart,
  configuration,
  gstData,
  infoDialog,
  noStockProducts,
  orderId,
  products,
  responsive,
  selectedOrderType,
  selectedCounterState,
  countersListState,
  merchantDetailsState,
  IsDarkChange,
  accessToken,
  orderType,
};
